import { type CompanyWithUI } from "@/components/shared/CompanyCardHorizontal";

const ensureArray = (value: unknown): any[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return [value];
};

export type DiscoverShortlistContext = {
  isAuthenticated: boolean;
  guestShortlistedIds: Set<string>;
  shortlistedIds: Set<string>;
};

export function resolveDiscoverIsShortlisted(
  companyId: string,
  { isAuthenticated, guestShortlistedIds, shortlistedIds }: DiscoverShortlistContext,
): boolean {
  return isAuthenticated ? shortlistedIds.has(companyId) : guestShortlistedIds.has(companyId);
}

export const mapListCompanies = (
  companies: any[],
  shortlistContext: DiscoverShortlistContext,
): CompanyWithUI[] =>
  (companies || []).map((item: any) => ({
    ...item,
    isShortlisted: resolveDiscoverIsShortlisted(item.id, shortlistContext),
  })) as CompanyWithUI[];

export const mapQuickSearchCompanies = (
  companies: any[],
  shortlistContext: DiscoverShortlistContext,
): CompanyWithUI[] =>
  (companies || []).map(
    (item: any) => {
      const companyId = item.companyId || item.id;
      return {
        id: companyId,
        gtid: item.gtid || "",
        legalName: "",
        tradeName: null,
        registrationNumber: null,
        yearOfIncorporation: null,
        website: null,
        email: null,
        phoneCountryCode: null,
        phoneNumber: null,
        description: item.description || null,
        subDescription: item.subDescription || null,
        customerOfferHighlight: ensureArray(item.customerOfferHighlight),
        industryCategory: ensureArray(item.industryCategory),
        subIndustry: ensureArray(item.subIndustry),
        collaborationIntent: ensureArray(item.collaborationIntent),
        coreCapabilities: ensureArray(item.coreCapabilities),
        secondaryCapabilities: [],
        keyDifferentiators: null,
        technologies: ensureArray(item.technologies),
        headquartersCountry: item.headquartersCountry || "",
        headquartersCity: item.headquartersCity || "",
        currentAddress: null,
        operatingCountries: ensureArray(item.operatingCountries ?? item.operating_countries),
        preferredCollaborationRegions: ensureArray(
          item.preferredCollaborationRegions ?? item.preferred_collaboration_regions,
        ),
        status: item.status || "VERIFIED",
        isShortlisted: resolveDiscoverIsShortlisted(companyId, shortlistContext),
      } as unknown as CompanyWithUI;
    },
  );
